<template>
<div class="chapter">
<div class="inner_page">
<h1>Copyright</h1>
<p class="sectiontop" style="text-align: center;">Diversion Books<br/>
  A Division of Diversion Publishing Corp.<br/>
  443 Park Avenue South, Suite 1008<br/>
  New York, NY 10016<br/>
<a href="http://www.DiversionBooks.com" target="_blank">www.DiversionBooks.com</a></p>
<p class="sectiontop" style="text-align: center;">Copyright © 1996 by Newton Thornburg<br/>
  All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
<p class="sectiontop" style="text-align: center;">This is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.</p>
<p class="sectiontop" style="text-align: center;">For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a></p>
<p class="sectiontop" style="text-align: center;">First Diversion Books edition April 2015<br/>
  ISBN: 978-1-62681-748-7</p>
<div style="page-break-after: always;">
<div style="display: none;"></div>
</div>
<h1 class="sigil_not_in_toc">Also by Newton Thornburg</h1>
<p class="sectiontop" style="text-align: center;"><span href="#/Text/morefrom" title="Link target outside of Sample">To Die in California<br/>
  Dreamland<br/>
  Cutter and Bone<br/>
  Eve’s Men<br/>
  Valhalla<br/>
  The Lion at the Door<br/>
  Beautiful Kate<br/>
  Black Angus</span></p>
<div style="page-break-after: always;">
<div style="display: none;"></div>
</div>
<p class="sectiontop" style="text-align: center;">To Janet</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?e771659e